import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CodeSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CodeSVG;
